import { BlogCategoryEntityResponse } from '@/gql/generated/graphql'
import React, { useState, useEffect } from 'react'
import { CollectionPageJsonLd } from 'next-seo';

type Props = {
  category: BlogCategoryEntityResponse
}

function BlogCategoryLd(props: Props) {
  const [entries, setEntries] = useState<any[]>()

  useEffect(() => {
    let posts = props.category.data?.attributes?.posts?.data.filter(post => post.attributes?.publishedAt).map((post) => {
      return {
        about: post.attributes?.excerpt,
        author: 'witopia',
        name: post.attributes?.seo?.metaTitle,
        datePublished: post.attributes?.publishedAt,
        keywords: post.attributes?.seo?.keywords,
        image: post.attributes?.seo?.metaImage?.data?.attributes?.url,
      }
    });

    setEntries(posts);

  }, [])
  return (
    <CollectionPageJsonLd
      name={props.category.data?.attributes?.title || "Blog"}
      hasPart={entries || []}
    />
  )
}

export default BlogCategoryLd